import { Component, Object3D, Property } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { GlobalEvents } from './global-events.js';
import { MusicManager, SoundManager, Sounds } from './music-manager.js';

export enum GameFlowStates {
    None = 0,
    MainMenu = 1,
    InGame = 2,
    Paused = 3,
    GameOver = 4,
    GameWon = 5,
}

export class GameFlowState {
    @property.enum(
        Object.keys(GameFlowStates).filter((e) => isNaN(Number(e))),
        GameFlowStates.MainMenu
    )
    state: GameFlowStates = GameFlowStates.MainMenu;

    @property.object({ required: true })
    startLocation!: Object3D;
}

const tempvec = new Float32Array(3);
export class GameFlowController extends Component {
    static TypeName = 'game-flow-controller';

    @property.array(Property.record(GameFlowState))
    gameFlowStates: GameFlowState[] = [];

    // Singleton
    private static _instance: GameFlowController;
    static get instance(): GameFlowController {
        return GameFlowController._instance;
    }

    private _currentState: GameFlowStates = GameFlowStates.None;
    get currentState(): GameFlowStates {
        return this._currentState;
    }

    onActivate(): void {
        this.engine.onXRSessionStart.add(this._enterXR);
        this.engine.onXRSessionEnd.add(this._exitXR);
    }
    onDeactivate(): void {
        this.engine.onXRSessionStart.remove(this._enterXR);
        this.engine.onXRSessionEnd.remove(this._exitXR);
    }

    init() {
        if (GameFlowController._instance) {
            console.error(
                'There can only be one instance of GameFlowController Component'
            );
        }
        GameFlowController._instance = this;
    }

    /**
     * Called when the main UI is ready, so we can start the game
     */
    async ready() {
        await MusicManager.instance.init();
        await SoundManager.instance.init();
        // Set the initial state to MainMenu
        this.setGameFlowState(GameFlowStates.MainMenu);
    }

    start(): void {}

    setGameFlowState(flowState: GameFlowStates) {
        if (this._currentState === flowState) {
            return;
        }

        this._currentState = flowState;
        const state = this.gameFlowStates.find(
            (state) => state.state === flowState
        );
        if (!state) {
            console.error(
                `GameFlowController: State ${flowState} not found in gameFlowStates`
            );
            return;
        }
        state.startLocation.getPositionWorld(tempvec);
        //TODO: Add Rotation
        GlobalEvents.instance.teleportRequested.dispatch(tempvec);
        GlobalEvents.instance.gameStateChanged.dispatch(this._currentState);
    }

    startGame() {
        this.setGameFlowState(GameFlowStates.InGame);
        MusicManager.instance.playMusic(Sounds.MainMusic);
    }

    _enterXR = () => {
        MusicManager.instance.playMusic(Sounds.IntroMusic);
    };
    _exitXR = () => {
        MusicManager.instance.stopMusic();
    };
}
